<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">
						题库列表
					</div>
					<div class="tab">
						<div @click="hot(-1)" :class="type==-1 ? 'action':''">全部题库</div>
						<div  @click="hot(1)" :class="type==1 ? 'action':''">精选题库</div>
						
					</div>
					<div class="search">
						<div class="searchtitle">题目名称</div>
						<div class="searchtitle1">
							<input class="searchinput" v-model="name" type="text" />
							<img class="searchimg" @click="searchClick()" src="../../assets/shudo/images/u1415.png" />
						</div>
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				<el-main>
					<div class="sort">
						<div @click="sortactivtClick('id','id')" :class="sortactivt=='id' ? 'sortactivt':''">综合排序</div>
						<div @click="sortactivtClick('difficulty','difficulty')" :class="sortactivt=='difficulty' ? 'sortactivt':''">难易程度</div>
						<div @click="sortactivtClick('number','number')" :class="sortactivt=='number' ? 'sortactivt':''">完成人数</div>
						<div @click="sortactivtClick(3)" :class="sortactivt==3 ? 'sortactivt':''">喜欢人数</div>
					</div>
					
					<div class="index-conent-left-connet1">
						<div class="list-div" v-for="(item,index) in list" :key="index">
						
							
							<div class="activt2" v-if="listtype==index">
								<div  @mouseenter="mouseEnter1(1)" @mouseleave="mouseLeave1" :class="mouseLeave1type==1 ? 'activt3':''">
									<img src="../../assets/shudo/images/u187.png" />
								</div>
								<div @click="classifyuseradd(item.id)"   @mouseenter="mouseEnter1(2)" @mouseleave="mouseLeave1" :class="mouseLeave1type==2 ? 'activt3':''">
									<img src="../../assets/shudo/images/u186.png" />
								</div>
								<div  @mouseenter="mouseEnter1(3)" @mouseleave="mouseLeave1" :class="mouseLeave1type==3 ? 'activt3':''">
									<img src="../../assets/shudo/images/u188.png" />
								</div>
							</div>
							<router-link :to="'/question/details?id='+item.id">
							<div class="list-div-titleh2"  @mouseenter="mouseEnter(index)" @mouseleave="mouseLeave">{{item.name}}</div>
							
							<img class="img1"  @mouseenter="mouseEnter(index)" @mouseleave="mouseLeave" :src="item.img|Ximgurl" />
							
							<div class="list-div-title">
								<img :src="item.merchant.avatar" />
								<div>{{item.merchant.username}}</div>
								<div>{{item.count}}道题</div>
							</div>
							<div class="list-div-bao">
								{{item.brief}}
							</div>
							<div class="list-div-top">
								<div>更新于：2021-02-06</div>
								<div>20</div>
							</div>
							</router-link>
						</div>
						
						
					</div>
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				sortactivt : 'id',
				name: '',
				list       : [],
				type : -1,
				listtype : -1,
				mouseLeave1type : 2
			}
	    },
		created() {
			let that = this;
			that.all({id:'id'});
		},
		methods:{
			//   鼠标移入
			mouseEnter(index){
				if( this.listtype != index){
					this.listtype = index;
				}
			    
				// console.log(activt2);
			},
			    //   鼠标移除
			mouseLeave(e){
				setTimeout(function () {
				    this.listtype=null;
				},500);
			   
				console.log(e);
			},
			mouseEnter1(index){
				  this.mouseLeave1type = index;
			},
			mouseLeave1(){
				setTimeout(function () {
				    this.mouseLeave1type=null;
				},500);
			},
			classifyuseradd(id){
				console.log(222);
				let that = this;
				that.$confirm('是否订阅', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
							
				}).then(({ value }) => {
					that.$http('post','/api/v1/classify/classifyuseradd',{type:0,classify_id:id}) .then(function (res) {
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					
					});
				}).catch(() => {
				  that.$message({
					type: 'info',
					message: '取消输入'
				  });       
				});
				
				
			},
			hot(e){
				this.all({hot:e});	
				this.type= e;
			},
			sortactivtClick(e,d){
				let that = this;
				that.sortactivt = e;
				that.all({e:d});
			},
			all(e){
				let that = this;
				that.$http('get','/api/v1/classify/all',e) .then(function (res) {
					that.list = res.data.list;
				});
			}
		},
	}
	
</script>

<style lang="less">
	@import  '../../../common/css/search.less';
	@import  '../../../common/css/sort.less';
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 60%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			font-style: normal;
			font-size: 1.5rem;
			color:#F2F2F2;
			height: 5.5rem;
			font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
		}
		.tab {
			display: flex;
			width: 63%;
			margin: auto;
			margin-top: 1rem;
			div {
				color: #A4A1A6;
				margin-left: 0.5rem;
				margin-right: 0.5rem;
				height: 1.4rem;
			}
			.action {
				border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
			}
		}
	
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	.index-conent-left-connet1{
		min-height: 14rem;
		display: flex;
		margin-top: 1rem;
		flex-wrap: wrap;
		.list-div {
			border-radius: 0.4rem;
			min-height: 9.5rem;
			background-color: #FFFFFF;
			margin-left: 1rem;
			margin-right: 1rem;
			width: 10rem;
			font-size: 0.5rem;
			margin-top: 1rem;
			img {
				display: block;
				margin: auto;
				width: 90%;
				
			}
			.img1 {
				height: 7rem;
			}
			.list-div-titleh2 {
				height: 1.5rem;
				padding-left: 0.6rem;
				line-height: 1.5rem;
				font-size: 0.2rem;
				display: flex;
				color: #000000;
				div:nth-last-child(1){
					margin-left: auto;
					padding-right: 0.3rem;
					color: #878787;
					font-size: 0.3rem;
				}
			}
			.list-div-title {
				padding-top: 0.3rem;
				padding-left: 0.6rem;
				display:flex;
				img {
					width: 22px;
					margin-left: 0;
				}
				div:nth-last-child(2){
					line-height: 2rem;
					flex:1;
					padding-left: 0.2rem;
					color: #181818c4;
				}
				div:nth-last-child(1){
					line-height: 2rem;
					flex:1;
					font-size: 0.5rem;
				}
			}
			.list-div-bao {
				padding-top: 0.1rem;
				padding-left: 0.6rem;
				color: #181818c4;
				font-size: 0.3rem;
				height: 2rem;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
			}
			.list-div-bao1{
				padding-top: 0.1rem;
				padding-left: 0.6rem;
				color: #181818c4;
				font-size: 0.3rem;
				display: flex;
				div:nth-last-child(2){
					width: 30%;
				}
				div:nth-last-child(1){
					display: flex;
					
					img{
						width: 10px;
					}
				}
			}
			.list-div-top {
				padding-top: 0.1rem;
				line-height: 1.5rem;
				display: flex;
				height: 2rem;
				div:nth-last-child(2){
					padding-left: 0.6rem;
					font-size: 0.5rem;
					flex:3;
				}
				div:nth-last-child(1){
					flex: 1;
					color: #d9001b;
					text-align: right;
					padding-right: 4px;
					font-size: 0.8rem;
				}
			}
			.list-div-top1 {
				padding-top: 0.1rem;
				line-height: 1.5rem;
				display: flex;
				height: 2rem;
				div:nth-last-child(2){
					flex:1;
					display: flex;
					padding-left: 0.6rem;
					line-height: 2rem;
					img{
						width: 1rem;
					}
					div {
						padding-left: 0.2rem;
					}
				}
				div:nth-last-child(1){
					flex:1;
					display: flex;
					margin-right: auto;
					line-height: 2rem;
					padding-left: 3rem;
					color: #d9001b;
					img{
						width: 0.7rem;
					}
					div {
						padding-left: 0.2rem;
					}
					
				}
			}
		}
		.activt2 {
			width: 10rem;
			height: 8.6rem;
			background-color: rgba(9, 7, 35, 0.788235294117647);
			position: absolute;
			z-index: 89;
			border-radius: 0.3rem 0.3rem 0 0 ; 
			// margin-left: 0.51rem;
			div {
				height: 2.86rem;
				img {
					padding-top: 0.4rem;
					width: 1.6rem;
					// height: 2.6rem;
				}
			}
			.activt3 {
				z-index: 99;
				background-color: rgba(9, 7, 35, 0.807843137254902);
			}
		}
	}
	
</style>
